<template>
    <div class="ls-cc-grid grid ls-credit-card--ie-fix">
        <div class="grid__col-sm-7">
            <div class="grid grid--bleed">
                <div class="grid__col-xs-12">
                    <label class="ls-label ls-margin--top" for="card-number">
                        Credit Card
                    </label>
                    <div class="ls-input__wrapper">
                        <span class="ls-input__icon" aria-hidden="true">
                            <i class="fa fa-credit-card fa-fw"></i>
                        </span>
                        <div
                            id="card-number"
                            v-ls-track.change="{
                                target: 'order-form--credit-card-number',
                            }"
                            name="card-number"
                            autocomplete="cc-number"
                            class="ls-input"
                            maxlength="30"
                            type="tel"
                        ></div>
                    </div>
                </div>
                <div class="grid__col-xs-7" style="padding-right: 2rem !important;">
                    <label class="ls-label ls-margin--top" for="card-expiry">
                        Exp date
                    </label>
                    <div class="ls-input__wrapper">
                        <span class="ls-input__icon" aria-hidden="true">
                            <i class="fa fa-lock fa-fw"></i>
                        </span>
                        <div
                            id="card-expiry"
                            v-ls-track.change="{
                                target: 'order-form--credit-card-expiry',
                                attachValue: true,
                            }"
                            name="card-expiry"
                            autocomplete="cc-csc"
                            class="ls-input"
                            maxlength="4"
                            type="tel"
                        />
                    </div>
                </div>
                <div class="grid__col-xs-5">
                    <label class="ls-label ls-margin--top" for="card-cvc">
                        CVC
                        <span class="ls-credit-card--helper-text cc-cvc-location-back"
                            >(code on back)</span
                        >
                    </label>
                    <div class="ls-input__wrapper">
                        <span class="ls-input__icon" aria-hidden="true">
                            <i class="fa fa-lock fa-fw"></i>
                        </span>
                        <div
                            id="card-cvc"
                            v-ls-track.change="{
                                target: 'order-form--credit-card-cvc',
                            }"
                            name="card-cvc"
                            autocomplete="cc-csc"
                            class="ls-input"
                            maxlength="4"
                            type="tel"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="grid__col-sm-5">
            <div class="ls-credit-card--all-cards ls-padding--top">
                <span class="ls-credit-card--helper-text">All major credit cards accepted</span>
                <div>
                    <i class="fa fa-2x fa-cc-mastercard"></i>&nbsp;
                    <i class="fa fa-2x fa-cc-visa"></i>&nbsp;
                    <i class="fa fa-2x fa-cc-amex"></i>&nbsp;
                    <i class="fa fa-2x fa-cc-discover"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            stripeToken: null,
            cardNumber: null,
            cardExpiry: null,
            cardCvc: null,
        };
    },
    computed: {
        stripeElements() {
            return this.$stripe.elements();
        },
    },
    mounted() {
        const stripeStyle = {
            base: {
                color: 'black',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '14px',
                '::placeholder': {
                    color: '#aab7c4',
                },
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a',
            },
        };

        this.cardNumber = this.stripeElements.create('cardNumber', { style: stripeStyle });
        this.cardNumber.mount('#card-number');
        this.cardExpiry = this.stripeElements.create('cardExpiry', { style: stripeStyle });
        this.cardExpiry.mount('#card-expiry');
        this.cardCvc = this.stripeElements.create('cardCvc', { style: stripeStyle });
        this.cardCvc.mount('#card-cvc');
    },
    beforeDestroy() {
        this.cardNumber.destroy();
        this.cardExpiry.destroy();
        this.cardCvc.destroy();
    },
    methods: {
        createToken() {
            return this.$stripe.createToken(this.cardNumber);
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-credit-card--helper-text {
    font-weight: normal;
    font-size: rem(-3);
    color: palette(gray, light);
}

.ls-credit-card--all-cards {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: palette(gray, light);

    > div {
        padding-top: rem(-5);
    }
}

.ls-credit-card--exp-date {
    display: flex;
    align-items: center;
}

.ls-credit-card--exp-date-input {
    flex: 1 0 45%;
}

.ls-credit-card--exp-date-slash {
    flex: 1 0 10%;
    font-size: rem(3);
    padding: 0 5px;
    text-align: center;
}

.ls-credit-card--ie-fix {
    @include min-screen(breakpoint(sm)) {
        max-width: 644px;
    }
}

.themed-app {
    .ls-credit-card--helper-text {
        color: $theme-color-gray-dark;
    }

    .ls-credit-card--all-cards {
        color: $theme-color-gray-dark;
    }
}
</style>
